export default __webpack_public_path__ + "static/media/attach.505a7635.svg";